import { React, useState, useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { CornerDownRight } from 'lucide-react';
import { FiExternalLink, FiX } from 'react-icons/fi';
import { setTimelineEpicList } from 'store/actions';
import LogWork from '../Board/LogWork';
import LinkWorkItemInput from '../Board/LinkWorkItemInput';
import ListLinkedWorkItems from '../Board/ListLinkedWorkItems';

import { CornerDownLeft } from 'lucide-react';
import { CheckIcon, CloseIcon } from '@chakra-ui/icons';
import { useCallback } from 'react';
import debounce from 'lodash.debounce';
import dayjs from 'dayjs';
import WebLink from '../Board/WebLink';
import WebLinkList from '../Board/ListWebLinks';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Box,
  Flex,
  Text,
  Badge,
  VStack,
  HStack,
  Tag,
  Input,
  Avatar,
  Grid,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  IconButton,
  Textarea,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Icon,
} from '@chakra-ui/react';
import TaskObject from '@atlaskit/object/task';
import StoryObject from '@atlaskit/object/story';
import BugObject from '@atlaskit/object/bug';

import {
  FaLock,
  FaEye,
  FaShareAlt,
  FaUserCircle,
  FaEdit,
} from 'react-icons/fa';
import { AiOutlineThunderbolt } from 'react-icons/ai';
import { Select } from 'antd';
import { MdOutlinePerson } from 'react-icons/md';
import CreatableSelect from 'react-select/creatable';
import httpInjectorService from 'services/http-injector.service';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { FiMoreHorizontal } from 'react-icons/fi';
import { DeleteIcon } from '@chakra-ui/icons';
import { Tooltip } from '@chakra-ui/react';
// import TimelineTaskmodal from './TimelineTaskmodal';
import { ThunderboltOutlined } from '@ant-design/icons';
import SkeletonWithLoaders from 'components/common/Spinner';
import {
  AddIcon,
  ChatIcon,
  RepeatIcon,
  BiReply,
  ArrowBackIcon,
  ChevronDownIcon,
} from '@chakra-ui/icons';
import { Spinner } from 'reactstrap';
// import SubTaskModal from './SubTaskModal';
import UserAvatar from '../../../../components/userAvatar/index';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
// import Epicmodalactivity from './Epicmodalactivity';
// import Epicmodalactivity from './Epicmodalactivity';
import Epicmodalactivity from './Epicmodalactivity';

import { AttachmentProvider } from '../attachments/AttachmentProvider';
import AttachmentMenuItem from '../attachments/AttachmentMenuItem';
import AttachmentList from './attachment/AttachmentList';
import ShareWorkItemModal from '../share/ShareWorkItemModal';

const TimelineEpicmodal = ({
  isOpen,
  onClose,
  epicDetails,
  projectId,
  fetchData,
  opentaskmodal,
  issueTypes,
  task,
  //   getTaskBoardDetails,
}) => {
  const [showEmployeePicker, setShowEmployeePicker] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [description, setDescription] = useState('');
  const [attachments, setAttachments] = useState([]);
  const [isShareOpen, setIsShareOpen] = useState(false); 
  const [selectedLabel, setSelectedLabel] = useState([]);
  const [labellist, setLabelList] = useState([]);
  const [epicdata, setEpicData] = useState({});
  const [sprintlist, setSprintlist] = useState({});
  const [selectedSprint, setSelectedSprint] = useState(null);
  const [comments, setComments] = useState([]);
  const [commentInput, setCommentInput] = useState('');
  const [replyInput, setReplyInput] = useState({});
  const [activeReply, setActiveReply] = useState(null);
  const [mentionQuery, setMentionQuery] = useState('');
  const [mentionSuggestions, setMentionSuggestions] = useState([]);
  const [taggedUsers, setTaggedUsers] = useState([]);
  const [newstatus, setnewstatus] = useState('');
  const [showChildInput, setShowChildInput] = useState(false);
  const [childTaskTitle, setChildTaskTitle] = useState('');
  const [childTasks, setChildTasks] = useState([]);
  const [loadingSubtasks, setLoadingSubtasks] = useState(false);
  const [editableTasks, setEditableTasks] = useState({});
  const [subtaskmodal, setSubtaskModal] = useState(false);
  const [selectedSubtask, setSelectedSubtask] = useState(null);
  const [epicModalOpen, setEpicModalOpen] = useState(false);
  const [selectedEpic, setSelectedEpic] = useState('');
  const [epicList, setEpicList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visibleReplies, setVisibleReplies] = useState({});
  const [editingText, setEditingText] = useState('');
  const [isEditingDescription, setIsEditingDescription] = useState(false);
  const [isEditingComment, setIsEditingComment] = useState(false);
  const [activeReplyEditor, setActiveReplyEditor] = useState(null);
  const [selectedIssueTypeId, setSelectedIssueTypeId] = useState(null);
  const EpicList = useSelector((state) => state?.Authentication?.Epiclist);
  // const [activeReply, setActiveReply] = useState(null);
  const [panelOpen, setPanelOpen] = useState(isOpen);
  const [reloadSubtasks, setReloadSubtasks] = useState(0);
  const [editedepicTitle, setEditedepicTitle] = useState(
    epicdata?.epic_name || '',
  );
  const [isEditingepicTitle, setIsEditingepicTitle] = useState(false);
  const [epicColor, setEpicColor] = useState('#8b5cf6');
  const [openLinkWorkItem, setOpenLinkWorkItem] = useState(false);
  const [refreshLinkedItems, setRefreshLinkedItems] = useState(false);
  const [showWebLink, setShowWebLink] = useState(false);
  const [refreshLinks, setRefreshLinks] = useState(false);
  const dispatch = useDispatch();
  const [refreshKey, setRefreshKey] = useState(0);

  const [storyPoints, setStoryPoints] = useState('');
  const assigneeList = useSelector(
    (state) => state?.Authentication?.assigneelist,
  );
  const statusList = useSelector(
    (status) => status?.Authentication?.taskstatuslist,
  );
  const timelinefilteredreqbody = useSelector(
    (state) => state?.Authentication?.timelinefilteredreqbody,
  );
  const isFilteredApplied = useSelector(
    (state) => state?.Authentication?.timelinefilter,
  );

  const roleId = Number(Cookies.get('task-role-id'));
  useEffect(() => {
    setPanelOpen(isOpen);
  }, [isOpen]);

  // optional threshold to stack panes vertically when panel is narrow
  const panelRef = useRef(null);
  const MIN_WIDTH = 200; // never smaller than this
  const MAX_SCREEN_RATIO = 0.45; // 55% of screen width

  // Right panel max width should leave some space
  const getMaxWidth = () =>
    Math.min(window.innerWidth * MAX_SCREEN_RATIO, window.innerWidth - 200);

  // ---- STATE ----
  const [panelWidth, setPanelWidth] = useState(() =>
    Math.min(Math.max(window.innerWidth * 0.4, MIN_WIDTH), getMaxWidth()),
  );

  // ---- RESIZE REFS ----
  const isResizing = useRef(false);
  const startX = useRef(0);
  const startWidth = useRef(0);

  // ---- MOUSE DOWN ----
  const onMouseDown = (e) => {
    isResizing.current = true;
    startX.current = e.clientX;
    startWidth.current = panelWidth;

    document.body.style.userSelect = 'none';
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

   const triggerRefresh = () => {
    setRefreshLinkedItems((prev) => !prev); // toggle
  };

  // ---- MOUSE MOVE ----
  const onMouseMove = (e) => {
    if (!isResizing.current) return;

    const dx = startX.current - e.clientX; // drag left => grow
    let newWidth = startWidth.current + dx;

    newWidth = Math.min(Math.max(newWidth, MIN_WIDTH), getMaxWidth());

    setPanelWidth(newWidth);
  };

  const fetchFilteredData = async () => {
    try {
      const response = await httpInjectorService.timelinefilterDetails(
        timelinefilteredreqbody,
      );

      if (response.status === 'success' && response.data?.epics) {
        const epicData = response?.data.epics || [];
        dispatch(
          setTimelineEpicList(
            response.status === 'success' ? response.data?.epics : [],
          ),
        );
      } else {
      }
    } catch (error) {
      console.error('Error fetching filtered data:', error);
    } finally {
      // setLoading(false);
    }
  };

  // ---- MOUSE UP ----
  const onMouseUp = () => {
    isResizing.current = false;
    document.body.style.userSelect = '';
    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseup', onMouseUp);
  };

  // ---- UPDATE WIDTH ON SCREEN RESIZE ----
  useEffect(() => {
    const onResize = () => {
      setPanelWidth((prev) => Math.min(prev, getMaxWidth()));
    };

    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // To store tagged usernames & ids

  const handleCloseWithSave = () => {
    // handleEpicUpdate();

    // handleAddLabel();
    // getTaskBoardDetails();

    onClose();
  };

  const epicColors = [
    '#8b5cf6', // Purple
    '#3b82f6', // Blue
    '#10b981', // Green
    '#f59e0b', // Amber
    '#ef4444', // Red
    '#6b7280', // Gray
  ];

  const handleCancel = () => {
    setEditedepicTitle(epicdata?.task_title || '');
    setIsEditingepicTitle(false);
  };

  const formatDateInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`; // Still YYYY-MM-DD, but local
  };

  const [dueDate, setDueDate] = useState(formatDateInput(epicdata.due_date));
  const [startDate, setStartDate] = useState(
    formatDateInput(epicdata.start_date),
  );

  const toggleReplies = (commentId, totalReplies) => {
    setVisibleReplies((prev) => ({
      ...prev,
      [commentId]:
        prev[commentId] && prev[commentId] < totalReplies
          ? totalReplies // show all
          : 2, // collapse back to 2
    }));
  };

   const handleSaveLink = (data) => {
  
    setRefreshLinks(prev => !prev);
    // you can store it, send API, etc
    setShowWebLink(false);
  };

  useEffect(() => {
    if (epicdata?.labels) {
      const formatted = epicdata.labels.map((label) => ({
        label: label.label_name,
        value: label.label_id,
        __isNew__: false,
      }));
      setSelectedLabel(formatted);
    }
  }, [epicdata]);

  const handleAddLabel = async (updatedLabels = selectedLabel) => {
    try {
      // Always use the latest labels passed from onChange
      if (!updatedLabels || updatedLabels.length === 0) {
      }

      const newLabels = updatedLabels.filter((label) => label.__isNew__);
      const existingLabels = updatedLabels.filter((label) => !label.__isNew__);

      const newLabelNames = newLabels.map((label) => label.label);
      const existingLabelIds = existingLabels.map((label) => label.value);

      const requestBody = {
        project_id: projectId,
        epic_id: epicDetails.epic_id,
      };

      // Attach ONLY if present
      if (newLabelNames.length > 0) {
        requestBody.new_label_name = newLabelNames;
      }

      requestBody.labels_id = existingLabelIds; // even if empty []

      const response =
        await httpInjectorService.createandADDepicLabels(requestBody);

      if (response.status !== 'success') {
        // error toast if needed
      }
    } catch (error) {
      toast.error('Something went wrong while adding labels', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };
  const getIssueIcon = (type) => {
    switch (type?.toUpperCase()) {
      case 'TASK':
        return <TaskObject size="medium" />;
      case 'BUG':
        return <BugObject size="medium" />;
      case 'STORY':
        return <StoryObject size="medium" />;
      default:
        return <TaskObject size="medium" />; // fallback
    }
  };

  const handleDeleteComment = async (commentId) => {
    try {
      const reqBody = {
        // project_id: taskdata.project_id,
        // task_id: taskdata.task_id,
        comment_id: commentId,
      };

      const res = await httpInjectorService.deleteComment(reqBody);
      if (res.status === 'success') {
        toast.success('Comment deleted successfully');
        // gettaskcomments();
      } else {
        toast.error(res.message || 'Failed to delete comment');
      }
    } catch (error) {
      toast.error('Something went wrong while deleting comment');
    }
  };

  const handleEditComment = async (commentId, updatedText) => {
    try {
      const reqBody = {
        project_id: projectId,
        comment_id: commentId,
        comment_text: updatedText,
      };

      const res = await httpInjectorService.editEpiccomment(reqBody);
      if (res.status === 'success') {
        toast.success('Comment updated successfully');
        getEpiccomments();
      } else {
        toast.error(res.message || 'Failed to update comment');
      }
    } catch (error) {
      toast.error('Something went wrong while updating comment');
    }
  };

  const getLabelList = async () => {
    try {
      const response = await httpInjectorService.getlabelList(projectId);
      if (response.status === 'success') {
        setLabelList(response?.data);
      } else {
        setLabelList([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // when epicDetails has a value (and not just an empty object), stop loading
    setLoading(true);

    getEpicDetails();
    if (isOpen && epicdata) {
      setLoading(false);
    }
  }, [epicDetails]);

  const getEpicDetails = async () => {
    let reqbody = {
      project_id: projectId,
      epic_id: epicDetails.epic_id,
    };
    try {
      const response = await httpInjectorService.getEpicdetails(reqbody);

      if (response.status === 'success') {
        setEpicData(response?.data);
      } else {
        setEpicData({});
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleEditChange = (subtaskId, field, value) => {
    setEditableTasks((prev) => ({
      ...prev,
      [subtaskId]: {
        ...prev[subtaskId],
        [field]: value,
      },
    }));
  };

  const handleopensubtaskmodal = (task) => {
    setSelectedSubtask(task);
    setSubtaskModal(true);
  };

  const saveSubtask = async (taskId, updatedFields = {}) => {
    const edited = editableTasks[taskId] || {};

    const original = childTasks.find((t) => t.issue_id === taskId);

    if (!original) {
      return;
    }

    const reqBody = {
      project_id: projectId, // or dynamic
      issue_id: taskId,
      issue_type_id: original?.issue_type_id,
      epic_id: epicDetails.epic_id,
      sprint_id: original?.sprint_id,
      issue_title:
        edited.title !== undefined ? edited.title : original?.issue_title,
      issue_status: updatedFields.status
        ? updatedFields.status
        : original.issue_status,
      issue_priority: updatedFields.priority
        ? updatedFields.priority
        : original.issue_priority,
      assignee_id: updatedFields.assignee_id
        ? updatedFields.assignee_id
        : original.assignee_id,
    };

    try {
      const response = await httpInjectorService.Taskedit(reqBody);
      if (response.status === 'success') {
        gettaskList();
        // Optionally refresh or give feedback
      }
    } catch (error) {
      console.error('Error saving subtask:', error);
    }
  };

  useEffect(() => {
    // gettaskcomments();
  }, []);

  const deleteChildTask = async (subtaskId) => {
    try {
      let reqbody = {
        project_id: projectId,
        task_id: [subtaskId],
      };
      let response = await httpInjectorService.deleteTask(reqbody);
      if (response.status === 'success') {
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        setChildTasks((prev) =>
          prev.filter((task) => task.subtask_id !== subtaskId),
        );
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error('Error deleting child task:', error);
    }
  };

  const getEpiccomments = async () => {
    let reqbody = {
      project_id: projectId,
      epic_id: epicDetails.epic_id,
    };
    try {
      const res = await httpInjectorService.getEpicComments(reqbody);
      if (res.status === 'success') {
        setComments(res.data);
      } else {
        console.error('Failed to fetch comments:', res.message);
      }
    } catch (err) {
      console.error('Error fetching comments:', err);
    }
  };

  const handleMentionSelect = (user) => {
    const words = commentInput.trim().split(/\s+/);
    words.pop(); // remove @something
    words.push(`@${user.username}`);
    const newText = words.join(' ') + ' ';
    setCommentInput(newText);
    setTaggedUsers((prev) => [...prev, user]); // Store tagged user info
    setMentionSuggestions([]);
    setMentionQuery('');
  };

  const getsprintlist = async () => {
    try {
      let response = await httpInjectorService.getsprintList(projectId);

      if (response.status === 'success') {
        const activeSprints = response.data?.active_sprints || [];

        // Convert to options format for CreatableSelect
        const options = activeSprints.map((sprint) => ({
          label: sprint.sprint_name,
          value: sprint.sprint_id,
        }));

        setSprintlist(options);

        // Preselect based on taskDetails
        const currentSprintName = epicdata?.sprint_name || ' ';
        const matchedSprint = options.find(
          (opt) => opt.label === currentSprintName,
        );

        if (matchedSprint) {
          setSelectedSprint(matchedSprint);
        }
      } else {
        setSprintlist([]);
      }
    } catch (error) {
      setSprintlist([]);
    }
  };

  useEffect(() => {
    if (isOpen && epicDetails?.epic_id) {
      getsprintlist();
      getLabelList();
      getEpiccomments();
      getEpicDetails();
      gettaskList();
    }
  }, [isOpen, epicDetails]);

  const handleOpenLinkWorkItem = () => {
    setOpenLinkWorkItem(true);
  };

  useEffect(() => {
    if (isOpen) {
      getsprintlist();
      setDescription(epicdata?.description);
      setDueDate(formatDateInput(epicdata?.due_date) || '');
      setStartDate(formatDateInput(epicdata?.start_date) || '');
      setStoryPoints(epicdata?.epic_story_points ?? '');
    }
  }, [isOpen, epicdata]);

  useEffect(() => {
    if (epicdata?.epic_colour) {
      setEpicColor(epicdata.epic_colour);
    }
  }, [epicdata]);

  const sprintOptions = Array.isArray(sprintlist)
    ? sprintlist
    : sprintlist?.data || [];

  const handleEpicUpdate = async (emp = {}) => {
    const finalEpicColor = emp?.epic_color || epicdata?.epic_colour;
    const finalBody = {
      project_id: projectId,
      epic_id: epicDetails.epic_id,
      epic_name: editedepicTitle || epicDetails?.name,
      sprint_id: selectedSprint?.value || epicdata?.sprint_id || null,
      epic_story_points: storyPoints || epicdata?.epic_story_points || null,
      assignee_id: emp?.user_id || epicdata?.assignee_id || null,
      description: description?.trim() || epicdata?.description || '',
      epic_status: emp?.status_name || epicdata?.epic_status,
      task_priority: epicdata.task_priority,
      start_date: startDate || epicdata?.start_date,
      due_date: dueDate || epicdata?.due_date,
      epic_colour: finalEpicColor,
    };

    try {
      const response = await httpInjectorService.UpdateEpicDetails(finalBody);

      if (response?.status === 'success') {
        getEpicDetails();

        if (isFilteredApplied === true) {
          fetchFilteredData();
        } else {
          fetchData();
        }
      }
    } catch (error) {
      toast.error('Something went wrong.');
    }
  };

  const getStatusColors = (status = '') => {
    const s = status.toUpperCase();

    switch (s) {
      case 'DONE':
        return { bg: 'green.300', color: 'black' };

      case 'TO DO':
        return { bg: 'gray.300', color: 'black' };

      default:
        return { bg: 'blue.300', color: 'black' };
    }
  };

  const currentStatus = newstatus || epicdata?.epic_status;
  const { bg, color } = getStatusColors(currentStatus);

  const debouncedUpdate = useCallback(
    debounce(() => handleEpicUpdate(), 400),
    [handleEpicUpdate],
  );

  const handleCommentChange = (value) => {
    setCommentInput(value);

    // Find the last "@mention" pattern anywhere in the text
    const match = value.match(/@(\w*)$/);

    if (match) {
      const query = match[1].toLowerCase();
      const suggestions = assigneeList.filter((user) =>
        user.username.toLowerCase().includes(query),
      );
      setMentionQuery(query);
      setMentionSuggestions(suggestions);
    } else {
      setMentionQuery('');
      setMentionSuggestions([]);
    }
  };

  const justOpenedRef = useRef(true);

  useEffect(() => {
    if (epicModalOpen) {
      //   getEpiclist(); // fetch only when modal is opened
    }
  }, [epicModalOpen]);

  const gettaskList = async () => {
    setLoadingSubtasks(true);
    let reqbody = {
      project_id: projectId,
      epic_id: epicDetails.epic_id,
    };
    try {
      const response = await httpInjectorService.gettaskwithEpicId(reqbody);
      setChildTasks(response.data);

      // assuming array of { id, title }
    } catch (error) {
    } finally {
      setLoadingSubtasks(false);
    }
  };

  const isEditable = [1, 2, 3].includes(roleId);

  // useEffect(() => {
  //   // getsubtaskList();
  // }, [taskdata?.task_id]);

  const handleAddSubtask = async () => {
    let reqbody = {
      project_id: projectId,
      epic_id: epicdata.epic_id,
      sprint_id: epicdata.sprint_id,
      issue_title: childTaskTitle || '',
      issue_type_id: selectedIssueTypeId,
      description: null,
      issue_status: 'TO DO',
      issue_priority: 'Medium',
      start_date: null,
      due_date: null,
      labels_id: null,
      subtask_assignee_id: null,
    };

    try {
      const response = await httpInjectorService.addtaskwithEpic(reqbody);
      if (response.status === 'success') {
        setChildTaskTitle('');
        setShowChildInput(false);
        setReloadSubtasks((prev) => prev + 1);
        gettaskList();
      } else {
        console.error('Failed to add subtask');
      }
    } catch (error) {
      throw error;
    }
  };

  const handlesubtaskmodal = () => {
    setSubtaskModal(false);
  };

  // const updatesubtask=async()=>{

  //   let reqbody={
  //     project_id:5,
  // subtask_id: 11,
  // title: "subtask edit test_12",
  // subtask_status: "Blocked",
  // subtask_priority: "Medium",
  // subtask_assignee_id: 157
  //   }
  //   try{
  //     let response=await httpInjectorService.updateSubtask(reqbody)
  //     if(response.status==="success"){

  //     }
  //   }catch(error){

  //   }
  // }

  useEffect(() => {
    if (isOpen) {
      justOpenedRef.current = true;
    }
  }, [isOpen]);

  const handleStatusChange = (status) => {
    setnewstatus(status);
  };

  const formatAssigneeLabel = (username) => {
    if (!username) return 'Unassigned';

    const nameParts = username.trim().split(' ');
    const initials = nameParts
      .map((n) => n[0])
      .join('')
      .toUpperCase();

    return `${initials} - ${username}`;
  };

  const fetchAttachments = async () => {
    if (!projectId || !epicDetails?.epic_id) {
      setAttachments([]);
      return;
    }

    try {
      const payload = {
        project_id: projectId,
        epic_id: epicDetails.epic_id || null,
        epic_key: epicdata?.epic_key || null,
      };

     

      const res = await httpInjectorService.getAttachment(payload);

      if (res?.status === 'success' && Array.isArray(res.data)) {
        setAttachments(res.data);
      } else {
        setAttachments([]);
      }
    } catch (error) {
      console.error('Error fetching attachments:', error);
      setAttachments([]);
    }
  };

  // delete attachment
  const handleDeleteAttachment = async (id) => {
    setAttachments((prev) => prev.filter((att) => att.attachment_id !== id));

    // Optional backend api call
    await httpInjectorService.deleteAttachment({
      attachment_id: id,
      project_id: projectId,
    });

    toast.success('Attachment removed', {
      position: 'top-right',
      autoClose: 3000,
    });
  };

  useEffect(() => {
    if (isOpen && projectId && epicDetails?.epic_id) {
      fetchAttachments();
    }
  }, [isOpen, projectId, epicDetails?.epic_id]);

  const handleLogSaved = () => {
    setRefreshKey((prev) => prev + 1);
  };

  

  const handleColorChange = (color) => {
    setEpicColor(color);

    // Update the epic color immediately
    handleEpicUpdate({ epic_color: color });
    // fetchData();
  };

  //   useEffect(() => {
  //     if (isOpen && (taskDetails?.task_id || taskDetails?.task?.task_id)) {
  //       setLoading(true);

  //       const fetchAllData = async () => {
  //         try {
  //           await Promise.all([
  //             // gettaskdata(),
  //             // getsprintlist(),
  //             // getLabelList(),
  //             // gettaskcomments(),
  //             // getsubtaskList(),
  //           ]);
  //         } catch (error) {
  //           console.error('Error loading modal data:', error);
  //         } finally {
  //           setLoading(false); // ✅ hide spinner after all API calls finish
  //         }
  //       };

  //       fetchAllData();
  //     }
  //   }, [isOpen, taskDetails]);

  // Extract values safely
  const status = epicdata?.task_status_count || {};
 

  const toDo = parseInt(status['TO DO'] || 0, 10);
  const review = parseInt(status['REVIEW'] || 0, 10);
  const inProgress = parseInt(status['IN PROGRESS'] || 0, 10);
  const done = parseInt(status?.DONE || 0, 10);
 

  const total = parseInt(status?.task_count || 0, 10);
 

  // Calculate % safely
  const donePercent = total > 0 ? (done / total) * 100 : 0;

  return (
    <div>
      <Box
        ref={panelRef}
        position="fixed"
        top="120px"
        right="0"
        width={`${panelWidth}px`}
        maxWidth="95vw"
        height="calc(100vh - 150px)"
        bg="white"
        boxShadow="lg"
        zIndex="1200"
        display="flex"
        flexDirection="column"
        borderLeft="1px solid #e2e8f0"
        overflow="hidden" // keep outer box non-scrolling; inner mainScroll handles scroll
        sx={{
          boxSizing: 'border-box',
          WebkitOverflowScrolling: 'touch',
          '::-webkit-scrollbar': { width: '8px' },
          '::-webkit-scrollbar-thumb': {
            background: '#CBD5E0',
            borderRadius: '8px',
          },
        }}
      >
        <Flex
          align="center"
          justify="space-between"
          px={6}
          py={3}
          borderBottom="1px solid #e2e8f0"
          flex="0 0 64px"
          minHeight="64px"
          zIndex="6"
          bg="white"
        >
          {/* Left Section: Checkbox + JIRA WorkItem */}
          <Flex align="center" gap={2}>
            <Text fontWeight="500" color="black">
              NubaxPulse WorkItem
            </Text>
          </Flex>

          {/* Right Section: Icons */}
          <Flex align="center" gap={4}>
            {/* Open in new tab icon */}
            {/* <Box
              as="button"
              onClick={() => {
                const url = `/admin/timeline/${projectId}/EpicDetails/${epicDetails.epic_id}`;
                window.open(url, '_blank');
              }}
              cursor="pointer"
              _hover={{ color: 'blue.500' }}
              bg="transparent"
              border="none"
            >
              <Icon as={FiExternalLink} boxSize={5} color="gray.700" />
            </Box> */}
            <a
              href={`/admin/timeline/${projectId}/EpicDetails/${epicDetails?.epic_id}`}
              rel="noopener noreferrer"
              target="_blank"
              style={{
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
              }}
            >
              <Icon as={FiExternalLink} boxSize={5} color="gray.700" />
            </a>

            {/* Close icon */}
            <Icon
              as={FiX}
              boxSize={5}
              color="gray.700"
              cursor="pointer"
              _hover={{ color: 'red.500' }}
              onClick={onClose}
            />
          </Flex>
        </Flex>

        <Flex
          justify="space-between"
          align="center"
          px={6}
          py={2}
          flex="0 0 auto"
          borderBottom="1px solid #e2e8f0"
          bg="white"
          zIndex="5"
        >
          <HStack spacing={0} align="center">
            <HStack spacing={1} align="center">
              <Text fontSize="md" color="gray.600">
                <span>
                  <ThunderboltOutlined style={{ color: '#884B9E' }} />{' '}
                  {epicdata?.epic_key}
                </span>
              </Text>
            </HStack>
          </HStack>

          <HStack spacing={2}>
            <IconButton
              icon={<FaLock />}
              size="sm"
              variant="ghost"
              aria-label="lock"
            />
            <LogWork
              work_Id={epicDetails?.epic_id}
              work_Type="EPIC"
              taskDetails={projectId}
              onSaved={handleLogSaved}
            />
            <IconButton
              icon={<FaEye />}
              size="sm"
              variant="ghost"
              aria-label="view"
            />
            <IconButton
              icon={<FaShareAlt />}
              size="sm"
              variant="ghost"
              aria-label="share"
              onClick={() => setIsShareOpen(true)}
            />
            <IconButton
              icon={<AiOutlineThunderbolt />}
              size="sm"
              variant="ghost"
              aria-label="action"
            />
          </HStack>
        </Flex>
        <Box
          flex="1 1 auto"
          minHeight={0} // critical for flex children to size properly
          overflowY="auto" // <-- single scrollbar lives here
          overflowX="hidden"
          bg="transparent"
        >
          {loading ? (
            <Flex justify="center" align="center" w="100%" h="300px">
              <SkeletonWithLoaders />
            </Flex>
          ) : (
            <div style={{ padding: '15px' }}>
              <Box
                as="section"
                display="flex"
                flexDirection="column"
                width="100%"
                minHeight={0}
              >
                <Box
                  as="section"
                  display="flex"
                  flexDirection="column"
                  width="100%"
                  minHeight={0}
                >
                  <Box mb={4}>
                    <HStack align="center" spacing={3}>
                      {/* COLOR BOX (always visible) */}
                      <Menu>
                        <MenuButton>
                          <Box
                            width="24px"
                            height="24px"
                            borderRadius="4px"
                            cursor="pointer"
                            border="1px solid #ddd"
                            bg={epicColor}
                          />
                        </MenuButton>

                        <MenuList p={2} zIndex={2}>
                          <HStack spacing={2}>
                            {epicColors.map((color) => (
                              <Box
                                key={color}
                                width="24px"
                                height="24px"
                                borderRadius="4px"
                                bg={color}
                                cursor="pointer"
                                border={
                                  epicColor === color
                                    ? '2px solid black'
                                    : '1px solid #ccc'
                                }
                                onClick={() => handleColorChange(color)}
                              />
                            ))}
                          </HStack>
                        </MenuList>
                      </Menu>

                      {/* EPIC TITLE TEXT / INPUT */}
                      {!isEditingepicTitle ? (
                        <Text
                          fontSize="2xl"
                          fontWeight="bold"
                          cursor="pointer"
                          onClick={() => {
                            if ([1, 2, 3].includes(roleId)) {
                              setEditedepicTitle(epicdata?.epic_name);
                              setIsEditingepicTitle(true);
                            }
                          }}
                        >
                          {editedepicTitle ||
                            epicdata?.epic_name ||
                            'Epic Title'}
                        </Text>
                      ) : (
                        <Box position="relative" width="100%">
                          <Input
                            value={editedepicTitle}
                            onChange={(e) => setEditedepicTitle(e.target.value)}
                            size="lg"
                            fontSize="2xl"
                            fontWeight="bold"
                            autoFocus
                            height="40px"
                            focusBorderColor="gray.300"
                            borderRadius="md"
                          />

                          <HStack
                            spacing={2}
                            position="absolute"
                            right="0"
                            top="100%"
                            mt={1}
                            pointerEvents="none"
                          >
                            <Box
                              p={1}
                              border="1px solid #d1d5db"
                              borderRadius="sm"
                              cursor="pointer"
                              pointerEvents="auto"
                              onClick={() => {
                                handleEpicUpdate(); // call the update function
                                setIsEditingepicTitle(false); // exit edit mode
                              }}
                            >
                              <CheckIcon boxSize={4} color="grey" />
                            </Box>

                            <Box
                              p={1}
                              border="1px solid #d1d5db"
                              borderRadius="sm"
                              cursor="pointer"
                              pointerEvents="auto"
                              onClick={handleCancel}
                            >
                              <CloseIcon boxSize={4} color="grey" />
                            </Box>
                          </HStack>
                        </Box>
                      )}
                    </HStack>

                    {[1, 2, 3].includes(roleId) && (
                      <AttachmentProvider
                        context={{
                          project_id: projectId,
                          epic_id: epicDetails.epic_id || null,
                          epic_key: epicdata?.epic_key || null,
                        }}
                        onUploaded={fetchAttachments}
                      >
                        <Menu>
                          <MenuButton
                            as={IconButton}
                            icon={<AddIcon />}
                            size="sm"
                            aria-label="Add actions"
                            bg="#f3f4f6"
                            border="1px solid #d1d5db"
                            borderRadius="md"
                            _hover={{ bg: '#e5e7eb' }}
                            _active={{ bg: '#e5e7eb' }}
                            color="gray.700"
                            mt={1}
                            mb={30}
                            position="relative"
                            zIndex={1}
                          />
                          <MenuList zIndex={2}>
                            <MenuItem onClick={() => setShowChildInput(true)}>
                              Create child work item
                            </MenuItem>
                            <MenuItem onClick={handleOpenLinkWorkItem}>
                              Link work Items
                            </MenuItem>
                            <MenuItem
                              onClick={() => console.log('Assign task clicked')}
                            >
                              Add connected work
                            </MenuItem>

                            <AttachmentMenuItem />

                            <MenuItem
                              onClick={() => {
                                    console.log('clicked');
                                    setShowWebLink(true);
                                  }}
                            >
                              Add web link
                            </MenuItem>
                            <MenuItem
                              onClick={() => console.log('Assign task clicked')}
                            >
                              Page
                            </MenuItem>
                            <MenuItem
                              onClick={() =>
                                console.log('Add attachment clicked')
                              }
                            >
                              Whiteboard
                            </MenuItem>
                          </MenuList>
                        </Menu>
                      </AttachmentProvider>
                    )}
                  </Box>

                  <Box mb={6}>
                    <Text fontWeight="semibold" mb={2}>
                      Description
                    </Text>

                    {!isEditingDescription ? (
                      <Box
                        p={3}
                        border="1px solid #e2e8f0"
                        borderRadius="8px"
                        minH="80px"
                        bg="white"
                        onClick={() =>
                          [1, 2, 3].includes(roleId) &&
                          setIsEditingDescription(true)
                        }
                        cursor={
                          ![1, 2, 3].includes(roleId) ? 'not-allowed' : 'text'
                        }
                      >
                        {description ? (
                          <Box
                            dangerouslySetInnerHTML={{ __html: description }}
                            fontSize="sm"
                          />
                        ) : (
                          <Text color="gray.400" fontSize="sm">
                            Add a description...
                          </Text>
                        )}
                      </Box>
                    ) : (
                      <Box>
                        <ReactQuill
                          theme="snow"
                          value={description}
                          onChange={setDescription}
                          placeholder="Write a description..."
                          modules={{
                            toolbar: [
                              ['bold', 'italic', 'underline', 'strike'],
                              [{ list: 'ordered' }, { list: 'bullet' }],
                              ['link', 'image', 'code-block'],
                              ['clean'],
                            ],
                          }}
                          style={{
                            backgroundColor: 'white',
                            borderRadius: '8px',
                            minHeight: '120px',
                          }}
                        />
                        <Flex justify="flex-end" mt={1} gap={2}>
                          <Button
                            size="sm"
                            colorScheme="blue"
                            borderRadius="0px"
                            onClick={() => {
                              setIsEditingDescription(false);
                              handleEpicUpdate('description', description);
                            }}
                          >
                            Save
                          </Button>
                          <Button
                            size="sm"
                            variant="ghost"
                            borderRadius="0px"
                            onClick={() => setIsEditingDescription(false)}
                          >
                            cancel
                          </Button>
                        </Flex>
                      </Box>
                    )}
                  </Box>

                   {openLinkWorkItem && (
                  <div style={{ marginTop: '16px' }}>
                    <LinkWorkItemInput
                      onCancel={() => setOpenLinkWorkItem(false)}
                      current_item_type={'epic'}
                      current_item_id={epicdata.epic_id}
                      onSuccess={triggerRefresh}
                    />
                  </div>
                )}
                 {showWebLink && (
                                                    <WebLink
                                                      onClose={() => setShowWebLink(false)}
                                                      onSave={handleSaveLink}
                                                      work_id={epicDetails.epic_id}
                                                      work_type={'epic'}
                                                    />
                                                  )}

                  {/* Add attachment UI */}
                  <Box mb={6}>
                    {attachments?.length > 0 && (
                      <AttachmentList
                        onDelete={handleDeleteAttachment}
                        attachments={attachments}
                      />
                    )}
                  </Box>

                  {/* <Epictasktable 
                assigneeList={assigneeList}
                statusList={statusList} 
                epicdata={epicdata}
                epicDetails={epicDetails}
                reload={reloadSubtasks}
                /> */}
                  <Tabs variant="unstyled">
                    {/* Tabs */}
                    <TabList gap={2}>
                      <Tab
                        fontSize="12px"
                        px="8px"
                        py="3px"
                        _selected={{
                          border: '1px solid #3182CE',
                          color: '#3182CE',
                          bg: 'white',
                          borderRadius: '4px',
                        }}
                      >
                        Subtasks
                      </Tab>

                      <Tab
                        fontSize="12px"
                        px="8px"
                        py="3px"
                        _selected={{
                          border: '1px solid #3182CE',
                          color: '#3182CE',
                          bg: 'white',
                          borderRadius: '4px',
                        }}
                      >
                        Linked Items
                      </Tab>
                    </TabList>

                    {/* Tab Content */}
                    <TabPanels mt={4}>
                      {/* Subtasks */}
                      <TabPanel p={0}>
                        {childTasks?.length > 0 &&
                          [1, 2, 3].includes(roleId) && (
                            <Box mt={6}>
                              <Text fontWeight="semibold" mb={2}>
                                Child work items
                              </Text>
                              {/* Progress Bar Section */}
                              {epicdata?.task_status_count && (
                                <Flex alignItems="center" gap={4}>
                                  <Box
                                    flex="1"
                                    display="flex"
                                    alignItems="center"
                                  >
                                    {/* Progress Bar */}
                                    <Flex
                                      w="100%"
                                      h="10px"
                                      borderRadius="8px"
                                      overflow="hidden"
                                      bg="#E2E8F0"
                                    >
                                      {(() => {
                                        const counts =
                                          epicdata.task_status_count;
                                        const total =
                                          Number(
                                            epicdata?.task_status_count
                                              ?.task_count,
                                          ) || 1;

                                        // Fixed
                                        const todo = Number(
                                          counts['TO DO'] || 0,
                                        );
                                        const done = Number(
                                          counts['DONE'] || 0,
                                        );

                                        // Dynamic statuses (merged into BLUE)
                                        let blue = 0;
                                        let blueStatusText = [];

                                        Object.keys(counts).forEach((key) => {
                                          if (
                                            key !== 'TO DO' &&
                                            key !== 'DONE' &&
                                            key !== 'task_count'
                                          ) {
                                            const c = Number(counts[key] || 0);
                                            blue += c;
                                            blueStatusText.push(`${key}: ${c}`);
                                          }
                                        });

                                        const todoPercent =
                                          (todo / total) * 100;
                                        const bluePercent =
                                          (blue / total) * 100;
                                        const donePercent =
                                          (done / total) * 100;

                                        return (
                                          <>
                                            {/* DONE (green) */}
                                            <Tooltip
                                              label={`DONE: ${done} of ${total}`}
                                              hasArrow
                                              placement="top"
                                            >
                                              <Box
                                                w={`${donePercent}%`}
                                                bg="#38A169"
                                                mx="1px"
                                                borderRadius="4px"
                                              />
                                            </Tooltip>

                                            {/* BLUE (other statuses) */}
                                            <Tooltip
                                              label={`IN PROGRESS: ${blue} of ${total}`}
                                              hasArrow
                                              placement="top"
                                            >
                                              <Box
                                                w={`${bluePercent}%`}
                                                bg="#3182CE"
                                                mx="1px"
                                                borderRadius="4px"
                                              />
                                            </Tooltip>
                                            {/* TO DO (grey) */}
                                            <Tooltip
                                              label={`TO DO: ${todo} of ${total}`}
                                              hasArrow
                                              placement="top"
                                            >
                                              <Box
                                                w={`${todoPercent}%`}
                                                bg="#A0AEC0"
                                                mx="1px"
                                                borderRadius="4px"
                                              />
                                            </Tooltip>
                                          </>
                                        );
                                      })()}
                                    </Flex>
                                  </Box>

                                  {/* Work Done Percentage */}
                                  <Text
                                    fontWeight="600"
                                    whiteSpace="nowrap"
                                    lineHeight="10px" // match progress bar height
                                    display="flex"
                                    alignItems="center" // perfect vertical alignment
                                  >
                                    Done: {Math.round(donePercent)}%
                                  </Text>
                                </Flex>
                              )}

                              <Box
                                borderWidth="1px"
                                borderRadius="md"
                                overflow="hidden"
                                boxShadow="sm"
                              >
                                <Box maxH="300px" overflowY="auto">
                                  <Table size="sm" border="1px solid #E2E8F0">
                                    <Thead
                                      bg="gray.100"
                                      position="sticky"
                                      top={0}
                                      zIndex={0}
                                    >
                                      <Tr>
                                        <Th borderRight="1px solid #E2E8F0"></Th>
                                        <Th
                                          borderRight="1px solid #E2E8F0"
                                          w="300px"
                                        >
                                          Work
                                        </Th>
                                        <Th borderRight="1px solid #E2E8F0">
                                          Priority
                                        </Th>
                                        <Th borderRight="1px solid #E2E8F0">
                                          Assignee
                                        </Th>
                                        <Th>Status</Th>
                                        {/* <Th>Actions</Th> */}
                                      </Tr>
                                    </Thead>

                                    <Tbody>
                                      {childTasks.map((task) => {
                                        const edited =
                                          editableTasks[task.issue_id] || {};

                                        const assigneeIdToUse =
                                          edited.assignee_id !== undefined
                                            ? edited.assignee_id
                                            : task.assignee_id;

                                        const assigneeObj = assigneeList.find(
                                          (a) => a.user_id === assigneeIdToUse,
                                        );

                                        const subtaskTitle =
                                          edited.title !== undefined
                                            ? edited.title
                                            : task.issue_title;
                                        const selectedStatus =
                                          edited.status ||
                                          task.issue_status ||
                                          'TO DO';
                                        const handleSave = () =>
                                          saveSubtask(task.issue_id);

                                        return (
                                          <Tr key={task.issue_id}>
                                            <Td w="150px">
                                              <Box
                                                as="button"
                                                onClick={() =>
                                                  opentaskmodal(task)
                                                }
                                                display="flex"
                                                alignItems="center"
                                                gap="6px"
                                                bg="transparent"
                                                border="none"
                                                cursor="pointer"
                                                color="#3182ce"
                                                fontWeight="500"
                                                padding={0}
                                                _hover={{
                                                  textDecoration: 'underline',
                                                  color: '#0056b3',
                                                }} // blue hover link
                                              >
                                                {getIssueIcon(task.issue_name)}
                                                {task.issue_key}
                                              </Box>
                                            </Td>

                                            {/* Editable title */}
                                            <Td
                                              borderRight="1px solid #E2E8F0"
                                              w="400px"
                                            >
                                              <Tooltip
                                                label={subtaskTitle}
                                                hasArrow
                                                placement="top"
                                                openDelay={300}
                                              >
                                                <Input
                                                  size="sm"
                                                  value={subtaskTitle}
                                                  onChange={(e) =>
                                                    handleEditChange(
                                                      task.issue_id,
                                                      'title',
                                                      e.target.value,
                                                    )
                                                  }
                                                  onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                      e.target.blur(); // lose focus first
                                                      handleSave();
                                                    }
                                                  }}
                                                  onBlur={() => {
                                                    // Only save if value actually changed
                                                    if (
                                                      subtaskTitle !==
                                                      task.issue_title
                                                    ) {
                                                      handleSave();
                                                    }
                                                  }}
                                                />
                                              </Tooltip>
                                            </Td>

                                            {/* Priority */}
                                            <Td
                                              borderRight="1px solid #E2E8F0"
                                              w="100px"
                                            >
                                              <Menu>
                                                <MenuButton
                                                  as={Button}
                                                  size="xs"
                                                  variant="outline"
                                                  colorScheme="gray"
                                                  rightIcon={
                                                    <ChevronDownIcon />
                                                  }
                                                >
                                                  {edited.priority ||
                                                    task.issue_priority ||
                                                    'Medium'}
                                                </MenuButton>
                                                <MenuList>
                                                  {[
                                                    'Low',
                                                    'Medium',
                                                    'High',
                                                  ].map((priority) => (
                                                    <MenuItem
                                                      key={priority}
                                                      onClick={() => {
                                                        handleEditChange(
                                                          task.issue_id,
                                                          'priority',
                                                          priority,
                                                        );
                                                        saveSubtask(
                                                          task.issue_id,
                                                          {
                                                            priority,
                                                          },
                                                        );
                                                      }}
                                                    >
                                                      {priority}
                                                    </MenuItem>
                                                  ))}
                                                </MenuList>
                                              </Menu>
                                            </Td>

                                            {/* Assignee */}
                                            <Td
                                              borderRight="1px solid #E2E8F0"
                                              w="120px"
                                            >
                                              <Menu isLazy>
                                                <Tooltip
                                                  label={
                                                    assigneeObj
                                                      ? assigneeObj.username
                                                      : 'Unassigned'
                                                  }
                                                  hasArrow
                                                  placement="top"
                                                  openDelay={300}
                                                >
                                                  <MenuButton
                                                    as={Button}
                                                    variant="ghost"
                                                    size="sm"
                                                    rightIcon={
                                                      <ChevronDownIcon />
                                                    }
                                                  >
                                                    <Box>
                                                      <UserAvatar
                                                        username={
                                                          assigneeObj
                                                            ? assigneeObj.username
                                                            : 'Unassigned'
                                                        }
                                                        size={24}
                                                      />
                                                    </Box>
                                                  </MenuButton>
                                                </Tooltip>

                                                <MenuList
                                                  maxH="200px"
                                                  overflowY="auto"
                                                  zIndex={1500}
                                                >
                                                  {assigneeList.map(
                                                    (assignee) => (
                                                      <MenuItem
                                                        key={assignee.user_id}
                                                        onClick={() => {
                                                          handleEditChange(
                                                            task.issue_id,
                                                            'assignee_id',
                                                            assignee.user_id,
                                                          );
                                                          saveSubtask(
                                                            task.issue_id,
                                                            {
                                                              assignee_id:
                                                                assignee.user_id,
                                                            },
                                                          );
                                                        }}
                                                      >
                                                        <Tooltip
                                                          label={
                                                            assignee.username
                                                          }
                                                          hasArrow
                                                          placement="right"
                                                          openDelay={300}
                                                        >
                                                          <Flex
                                                            align="center"
                                                            gap="2"
                                                          >
                                                            <UserAvatar
                                                              username={
                                                                assignee.username
                                                              }
                                                              size={24}
                                                            />
                                                            <Text fontSize="sm">
                                                              {
                                                                assignee.username
                                                              }
                                                            </Text>
                                                          </Flex>
                                                        </Tooltip>
                                                      </MenuItem>
                                                    ),
                                                  )}
                                                </MenuList>
                                              </Menu>
                                            </Td>

                                            {/* Status */}
                                            <Td>
                                              <Menu>
                                                <MenuButton
                                                  as={Button}
                                                  size="xs"
                                                  variant="outline"
                                                  colorScheme="gray"
                                                  rightIcon={
                                                    <ChevronDownIcon />
                                                  }
                                                >
                                                  {selectedStatus}
                                                </MenuButton>
                                                <MenuList>
                                                  {statusList.map((status) => (
                                                    <MenuItem
                                                      key={status.status_name}
                                                      onClick={() => {
                                                        handleEditChange(
                                                          task.issue_id,
                                                          'status',
                                                          status.status_name,
                                                        );
                                                        saveSubtask(
                                                          task.issue_id,
                                                          {
                                                            status:
                                                              status.status_name,
                                                          },
                                                        );
                                                      }}
                                                    >
                                                      {status.status_name}
                                                    </MenuItem>
                                                  ))}
                                                </MenuList>
                                              </Menu>
                                            </Td>

                                            {/* Actions */}
                                            {/* <Td>
                                      <Flex align="center" gap={2}>
                                        <Button
                                          size="xs"
                                          colorScheme="blue"
                                          onClick={() =>
                                            saveSubtask(task.task_id)
                                          }
                                        >
                                          Save
                                        </Button>
                                        <Menu>
                                          <MenuButton
                                            as={IconButton}
                                            icon={<FiMoreHorizontal />}
                                            variant="ghost"
                                            size="sm"
                                          />
                                          <MenuList>
                                            {[1, 2, 3].includes(roleId) && (
                                              <MenuItem
                                                icon={
                                                  <DeleteIcon color="red.500" />
                                                }
                                                onClick={() =>
                                                  deleteChildTask(task.task_id)
                                                }
                                                minW="auto"
                                              >
                                                Delete
                                              </MenuItem>
                                            )}
                                          </MenuList>
                                        </Menu>
                                      </Flex>
                                    </Td> */}
                                          </Tr>
                                        );
                                      })}
                                    </Tbody>
                                  </Table>
                                </Box>
                              </Box>
                            </Box>
                          )}
                      </TabPanel>

                      {/* Linked Items */}
                      <TabPanel p={0}>
                        <ListLinkedWorkItems
                          item_id={epicDetails.epic_id}
                          item_type={'epic'}
                          refreshFlag={refreshLinkedItems}
                        />
                      </TabPanel>
                    </TabPanels>
                  </Tabs>

                  

                  {/* Comment Input */}

                  {/* <Epictasktable
                  assigneeList={assigneeList}
                  statusList={statusList}
                  epicdata={epicdata}
                  epicDetails={epicDetails}
                  reload={reloadSubtasks}
 
                  /> */}

                  {/* {showChildInput && (
                    <HStack mb={4} mt={4}>
                      <Text fontWeight="semibold" mb={2}>
                        Subtask
                      </Text>
                      <div style={{ display: 'flex', gap: 8 }}>
  <Input
    placeholder="What needs to be done?"
    size="sm"
    value={childTaskTitle}
    onChange={(e) => setChildTaskTitle(e.target.value)}
    onKeyDown={(e) =>
      e.key === 'Enter' && handleAddSubtask()
    }
  />

  <Select
    value={selectedIssueTypeId}
    onChange={(value) => setSelectedIssueTypeId(value)}
    size="small"
    style={{ width: 90 }}
    dropdownStyle={{ zIndex: 99999 }}
    popupMatchSelectWidth={false}
  >
    {issueTypes.map((type) => (
      <Select.Option
        key={type.issue_type_id}
        value={type.issue_type_id}
        label={type.issue_type}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          {type.issue_type === 'TASK' && (
            <TaskObject width={18} stroke="#0052CC" />
          )}
          {type.issue_type === 'STORY' && (
            <StoryObject width={18} stroke="#36B37E" />
          )}
          {type.issue_type === 'BUG' && (
            <BugObject width={18} stroke="#FF5630" />
          )}
          <span>{type.issue_type}</span>
        </div>
      </Select.Option>
    ))}
  </Select>
</div>

                      <Button
                        size="sm"
                        colorScheme="blue"
                        borderRadius="0px"
                        onClick={handleAddSubtask}
                      >
                        <CornerDownLeft />
                      </Button>
                      <Button
                        size="sm"
                        borderRadius="0px"
                        onClick={() => setShowChildInput(false)}
                      >
                        Cancel
                      </Button>
                    </HStack>
                  )} */}
                  {showChildInput && (
                    <HStack
                      mb={4}
                      mt={4}
                      align="center"
                      spacing={2}
                      width="100%"
                    >
                      {/* Label */}
                      <Text fontWeight="semibold" minW="60px">
                        Subtask
                      </Text>

                      {/* Combined Input + Select */}
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          border: '1px solid #CBD5E0',
                          borderRadius: 6,
                          width: '100%',
                          background: '#fff',
                        }}
                      >
                        {/* Text Input */}
                        <Input
                          variant="unstyled"
                          placeholder="What needs to be done?"
                          size="sm"
                          value={childTaskTitle}
                          onChange={(e) => setChildTaskTitle(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' && childTaskTitle.trim()) {
                              handleAddSubtask();
                            }
                          }}
                          style={{ flex: 1, paddingLeft: 8 }}
                        />

                        {/* Divider */}
                        <div
                          style={{
                            width: 1,
                            height: 24,
                            backgroundColor: '#E2E8F0',
                            margin: '0 6px',
                          }}
                        />

                        {/* Issue Type Select */}
                        <Select
                          value={selectedIssueTypeId}
                          onChange={(value) => setSelectedIssueTypeId(value)}
                          size="small"
                          bordered={false}
                          optionLabelProp="label" // 👈 icon only when selected
                          style={{
                            width: 50,
                            background: '#F7FAFC',
                            display: 'flex',
                            justifyContent: 'center',
                          }}
                          dropdownStyle={{ zIndex: 99999 }}
                        >
                          {issueTypes.map((type) => (
                            <Select.Option
                              key={type.issue_type_id}
                              value={type.issue_type_id}
                              label={
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                  }}
                                >
                                  {type.issue_type === 'TASK' && (
                                    <TaskObject width={20} stroke="#0052CC" />
                                  )}
                                  {type.issue_type === 'STORY' && (
                                    <StoryObject width={20} stroke="#36B37E" />
                                  )}
                                  {type.issue_type === 'BUG' && (
                                    <BugObject width={20} stroke="#FF5630" />
                                  )}
                                </div>
                              }
                            >
                              {/* Dropdown item: icon + text */}
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 6,
                                }}
                              >
                                {type.issue_type === 'TASK' && (
                                  <TaskObject width={18} stroke="#0052CC" />
                                )}
                                {type.issue_type === 'STORY' && (
                                  <StoryObject width={18} stroke="#36B37E" />
                                )}
                                {type.issue_type === 'BUG' && (
                                  <BugObject width={18} stroke="#FF5630" />
                                )}
                                <span>{type.issue_type}</span>
                              </div>
                            </Select.Option>
                          ))}
                        </Select>
                      </div>

                      {/* Add Button */}
                      <Button
                        size="sm"
                        colorScheme="blue"
                        borderRadius="0px"
                        onClick={handleAddSubtask}
                        isDisabled={!childTaskTitle.trim()}
                      >
                        <CornerDownLeft />
                      </Button>

                      {/* Cancel Button */}
                      <Button
                        size="sm"
                        borderRadius="0px"
                        onClick={() => setShowChildInput(false)}
                      >
                        Cancel
                      </Button>
                    </HStack>
                  )}
                </Box>
                <Box
                  flexShrink={0}
                  width="100%"
                  p={6}
                  marginTop={2}
                  borderTop="1px solid #e2e8f0"
                  bg="gray.50"
                  zIndex="1"
                >
                  <Tooltip
                    label={!isEditable ? 'You do not have permission' : ''}
                  >
                    <Menu isDisabled={!isEditable}>
                      <MenuButton
                        as={Button}
                        rightIcon={<ChevronDownIcon />}
                        size="sm"
                        mb={4}
                        p={0}
                        px={0}
                        minW="fit-content"
                        width="fit-content"
                        height="auto"
                        borderRadius="md"
                        bg={bg} // status background
                        color={color} // text color
                        border="1px solid #ccc"
                        _hover={{ bg }}
                        _active={{ bg }}
                      >
                        <Badge
                          bg="transparent"
                          color={color}
                          fontSize="0.8em"
                          p={1}
                        >
                          {currentStatus}
                        </Badge>
                      </MenuButton>

                      {isEditable && (
                        <MenuList>
                          {statusList.map((status) => {
                            const { bg, color } = getStatusColors(
                              status.status_name,
                            );
                            return (
                              <MenuItem
                                key={status.id}
                                onClick={() => {
                                  handleStatusChange(status.status_name);
                                  handleEpicUpdate(status);
                                }}
                              >
                                <Badge
                                  bg={bg}
                                  color={color}
                                  fontSize="0.75em"
                                  p={1}
                                  borderRadius="md"
                                >
                                  {status.status_name}
                                </Badge>
                              </MenuItem>
                            );
                          })}
                        </MenuList>
                      )}
                    </Menu>
                  </Tooltip>
                  
                                                  <WebLinkList
                                                    work_id={epicDetails.epic_id}
                                                    work_type={'epic'}
                                                    refreshFlag={refreshLinks}
                                                  />

                  {/* Epic-level only share work item */}
                  <ShareWorkItemModal
                    isOpen={isShareOpen}
                    onClose={() => setIsShareOpen(false)}
                    project_id={projectId}
                    epic_id={epicdata?.epic_id}
                    issue_id={task?.issue_id || epicdata?.issue_id}
                    issue_type_id={
                      task?.issue_type ||
                      task?.issue_type_id ||
                      epicdata?.issue_type_id
                    }
                  />

                  <Grid
                    templateColumns="120px 1fr"
                    rowGap={5}
                    columnGap={6}
                    alignItems="start"
                  >
                    <Text fontWeight="semibold">Assignee</Text>
                    <Tooltip
                      label={!isEditable ? 'You do not have permission' : ''}
                    >
                      <Popover
                        isOpen={showEmployeePicker}
                        onClose={() => setShowEmployeePicker(false)}
                      >
                        <Box position="relative" width="fit-content">
                          <PopoverTrigger>
                            <HStack
                              spacing={2}
                              onClick={() =>
                                setShowEmployeePicker(!showEmployeePicker)
                              }
                              cursor="pointer"
                            >
                              {selectedEmployee?.username ||
                              epicdata?.assignee_name ? (
                                <>
                                  <UserAvatar
                                    username={
                                      selectedEmployee?.username ||
                                      epicdata?.assignee_name
                                    }
                                    size={24}
                                  />
                                  <Text fontSize="sm">
                                    {selectedEmployee?.username ||
                                      epicdata?.assignee_name}
                                  </Text>
                                </>
                              ) : (
                                <HStack spacing={1} color="gray.500">
                                  <MdOutlinePerson size={20} />
                                  <Text fontSize="sm">Unassigned</Text>
                                </HStack>
                              )}
                            </HStack>
                          </PopoverTrigger>
                        </Box>
                        {isEditable && (
                          <PopoverContent width="auto">
                            <PopoverBody>
                              {assigneeList?.length > 0 ? (
                                <Box maxH="200px" overflowY="auto">
                                  {assigneeList.map((emp) => (
                                    <Box
                                      key={emp.user_id}
                                      onClick={() => {
                                        setSelectedEmployee(emp); // store full object, not just ID
                                        setShowEmployeePicker(false);
                                        handleEpicUpdate(emp);
                                      }}
                                      display="flex"
                                      alignItems="center"
                                      px={2}
                                      py={1}
                                      borderRadius="md"
                                      cursor="pointer"
                                      bg={
                                        selectedEmployee?.user_id ===
                                        emp.user_id
                                          ? '#e6f4ff'
                                          : 'transparent'
                                      }
                                      _hover={{ bg: '#f1f5f9' }}
                                    >
                                      <UserAvatar
                                        username={emp.username}
                                        size={24}
                                        style={{ marginRight: '8px' }}
                                      />
                                      <Text fontSize="sm">{emp.username}</Text>
                                    </Box>
                                  ))}
                                </Box>
                              ) : (
                                <Text fontSize="sm" color="gray.500">
                                  No employees found
                                </Text>
                              )}
                            </PopoverBody>
                          </PopoverContent>
                        )}
                      </Popover>
                    </Tooltip>

                    <Text fontWeight="semibold">Labels</Text>

                    <Box w="100%">
                      <CreatableSelect
                        isDisabled={![1, 2, 3].includes(roleId)}
                        isClearable
                        isMulti
                        placeholder="Select or create label"
                        value={selectedLabel} // ✔ ONLY this
                        options={labellist.map((label) => ({
                          label: label.label_name,
                          value: label.label_id,
                          __isNew__: false,
                        }))}
                        onChange={(newValue) => {
                          const updated = newValue || [];

                          setSelectedLabel(updated);
                          handleAddLabel(updated); // ← Pass updated list
                        }}
                      />
                    </Box>

                    <Text fontWeight="semibold">Due date</Text>
                    <Input
                      type="date"
                      size="sm"
                      value={dueDate}
                      onChange={(e) => setDueDate(e.target.value)}
                      onBlur={handleEpicUpdate}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleEpicUpdate(); // ✅ Save on Enter
                          e.target.blur();
                        }
                      }}
                      isDisabled={![1, 2, 3].includes(roleId)}
                    />

                    <Text fontWeight="semibold">Start date</Text>
                    <Input
                      type="date"
                      size="sm"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      onBlur={handleEpicUpdate}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleEpicUpdate();
                          e.target.blur();
                        }
                      }}
                      isDisabled={![1, 2, 3].includes(roleId)}
                    />

                    <Text fontWeight="semibold">Sprint</Text>
                    <Text>
                      {/* {taskDetails?.task?.sprint_name || taskDetails?.sprint_name || 'SCRUM Sprint 1'} */}
                      <CreatableSelect
                        isDisabled={![1, 2, 3].includes(roleId)}
                        placeholder="Select or create sprint"
                        isClearable
                        value={
                          selectedSprint ||
                          sprintOptions.find(
                            (s) => s.label === epicDetails?.sprint_name,
                          ) ||
                          (epicdata?.sprint_name
                            ? {
                                label: epicdata.sprint_name,
                                value: epicdata.sprint_id,
                              }
                            : null)
                        }
                        options={sprintOptions}
                        onChange={(newValue) => {
                          setSelectedSprint(newValue);
                          handleEpicUpdate();
                        }}
                        formatCreateLabel={(inputValue) =>
                          `Create new sprint: "${inputValue}"`
                        }
                      />
                    </Text>

                    <Text fontWeight="semibold">Story points</Text>
                    <Input
                      size="sm"
                      placeholder="Add story points"
                      w="100%"
                      type="number"
                      value={storyPoints}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Keep only digits (0–9)
                        const onlyInt = value.replace(/[^\d]/g, '');

                        setStoryPoints(onlyInt);
                      }} // <-- update state
                      onBlur={debouncedUpdate}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleEpicUpdate();
                          e.target.blur();
                        }
                      }}
                      isDisabled={![1, 2, 3].includes(roleId)}
                    />

                    <Text fontWeight="semibold">Development</Text>
                    <VStack align="start" spacing={2}></VStack>

                    <Text fontWeight="semibold">Reporter</Text>
                    <HStack align="center" spacing={2}>
                      <Avatar
                        name={epicdata?.created_by_name || 'Unknown'}
                        size="xs"
                      />
                      <Text fontSize="sm" lineHeight="1">
                        {epicdata?.created_by_name || 'Unknown'}
                      </Text>
                    </HStack>
                  </Grid>
                  <div
                    style={{
                      marginTop: 0,
                      padding: '12px 16px',
                      // border: '1px solid #e6e6e6',
                      borderRadius: 8,
                      // background: '#fff',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 10,
                    }}
                  >
                    <div
                      style={{ display: 'flex', alignItems: 'center', gap: 16 }}
                    >
                      <span style={{ width: 120, fontWeight: 300 }}>
                        Created at
                      </span>
                      <Text style={{ color: '#333' }}>
                        {epicdata?.created_at
                          ? dayjs(epicdata?.created_at).format(
                              'DD MMM YYYY, hh:mm A',
                            )
                          : 'Unknown'}
                      </Text>
                    </div>
                    <div
                      style={{ display: 'flex', alignItems: 'center', gap: 16 }}
                    >
                      <span style={{ width: 120, fontWeight: 300 }}>
                        Updated at
                      </span>
                      <Text style={{ color: '#333' }}>
                        {epicdata?.updated_at
                          ? dayjs(epicdata?.updated_at).format(
                              'DD MMM YYYY, hh:mm A',
                            )
                          : 'Unknown'}
                      </Text>
                    </div>
                  </div>
                </Box>
               

                <Epicmodalactivity
                  epicDetails={epicDetails}
                  refreshKey={refreshKey}
                />
              </Box>
            </div>
          )}
          <Box
            onMouseDown={onMouseDown}
            onTouchStart={onMouseDown}
            position="fixed"
            right={`${panelWidth}px`}
            top="0"
            width="6px"
            height="100vh"
            cursor="ew-resize"
            bg="transparent"
            _hover={{ bg: 'rgba(0,0,0,0.05)' }}
            zIndex="2000"
          >
            {/* Center thin line like your old UI */}
            <Box
              position="absolute"
              top="50%"
              left="2px"
              transform="translateY(-50%)"
              width="2px"
              height="44px"
              bg="gray.300"
              borderRadius="md"
            />
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default TimelineEpicmodal;
